import React, { useContext, useEffect, useState, useRef } from "react";
import Application from "../../../StateContext/Application.js";
import { apiurl } from "../../../../../path.js";
import Select from "react-select";
import {
  ProjectCreation64,
  BudgetHeadCreationBlue32,
  Cancel32,
  Add32,
  DeleteRed32,
  EditBlueBlue32,
  submit,
  Tax32,
  UpdateWhite32,
  EditIcon,
  DeleteIcon,
  Edit32WHITE,
  Delete32WHITE,
} from "../../../../../public/LoginImages/importimages";

// 27-10 for cal
const getMinDateTime = () => {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, "0");
  const day = String(now.getDate()).padStart(2, "0");
  const hours = String(now.getHours()).padStart(2, "0");
  const minutes = String(now.getMinutes()).padStart(2, "0");
  return `${year}-${month}-${day}T${hours}:${minutes}`;
};
const LimitAllocation = ({
  isEdit = false,
  projectDatainward,
  onSuccess,
  onCancel,
}) => {
  const operation = useContext(Application);
  const {
    GetProjectInfo,
    GetBudgetHeadInfo,
    ReleaseFDUTF,
    ViewAllReleaseFDUTF,
    GetAgencyList,
  } = operation;
  const [errors, setErrors] = useState({});//08-10
  const [projectId, setProjectId] = useState([]);
  const [HeadId, setHeadID] = useState([]);
  const [relatedHeadID, setRelatedHeadID] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [AlltableData, setAllTableData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [allProjects, setAllProjects] = useState([]);
  const [fundSearchTerm, setFundSearchTerm] = useState("");//24-10 
  // 08-10 add pagination
  const [fundCurrentPage, setFundCurrentPage] = useState(1);
const fundItemsPerPage = 10;

 
// 24-10 add searh
const filteredFundTableData = AlltableData.filter((item) => {
  const search = fundSearchTerm.trim().toLowerCase();

  if (!search) return true;

  return [
    item.FinancialYear,
    item.ProjectName,
    item.ProjectCost,
    item.ReleaseAmount,
    item.ReleaseDate
      ? new Date(item.ReleaseDate).toLocaleDateString("en-IN")
      : "",
  ].some((value) =>
    String(value ?? "").toLowerCase().includes(search)
  );
});

const fundTotalPages = Math.ceil(
  filteredFundTableData.length / fundItemsPerPage
);

const fundStartIndex =
  (fundCurrentPage - 1) * fundItemsPerPage;

const currentFundTableData = filteredFundTableData.slice(
  fundStartIndex,
  fundStartIndex + fundItemsPerPage
);

useEffect(() => {
  setFundCurrentPage(1);
}, [fundSearchTerm, AlltableData]);
// ---------------------
// ---------------------


  const releaseDateRef = useRef(null);
  const [data, setData] = useState({
    FinancialYear: "",
    ProjectName: "",
    ProjectID: "",
    ReleaseAmountTillDate: "",
    BudgetHeadID: null,
    BudgetHeadName: "",
    Agency_Name: "",
    Agency: "",
    ReleaseAmount: 0,
    ReleaseDate: null,
    piu: "",
    Scheme: "",
    EsitmateAmount: 0,
    ProjectCost: 0,
    UsedAmount: 0,
    RemainingAmount: 0,
    Remark: "",
    ReleaseSanctionCopy: "",
  });
  const [editIndex, setEditIndex] = useState(null);
  const [filteredProjects, setFilteredProjects] = useState([]);
  const [indexofediting, setIndexofEditing] = useState(null);
  const [agencyList, setAgencyList] = useState([]);

  const [releaseSanctionCopy, setReleaseSanctionCopy] = useState(null);

  const getMinDateTime = () => {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, "0");
    const day = String(now.getDate()).padStart(2, "0");
    const hours = String(now.getHours()).padStart(2, "0");
    const minutes = String(now.getMinutes()).padStart(2, "0");

    return `${year}-${month}-${day}T${hours}:${minutes}`;
  };

  const minDateTime = getMinDateTime();

  // 02-10
  const HandleChangeData = (e) => {
  const { name, value } = e.target;

  // Year validation only for the date field
  if (name === "ReleaseDate" && value) {
    const year = value.split("-")[0];
    if (year.length > 4 || !/^\d{1,4}$/.test(year)) {
      return;
    }
  }
  // 08-10
  setData((prev) => ({
    ...prev,
    [name]: value,
  }));
 
  setErrors((prev) => ({
    ...prev,
    [name]: "",
  }));

  // setData({ ...data, [name]: value }); 23-10
};
// 27-10
const handleReleaseDateChange = (e) => {
  const input = e.target;
  let value = input.value;

  const prevDate = (data.ReleaseDate || "").split("T")[0];
  const newDate = (value || "").split("T")[0];
  const now = getMinDateTime();

  // If today is picked, the default time may be slightly in the past,
  // so snap it to the current time.
  if (value && newDate === now.split("T")[0] && value < now) {
    value = now;
  }

  HandleChangeData({ target: { name: "ReleaseDate", value } });

  if (!newDate) return;

  // If the field was empty, compare against today (the picker opens on today)
  const baseline = prevDate || now.split("T")[0];

  const [py, pm, pd] = baseline.split("-").map(Number);
  const [ny, nm, nd] = newDate.split("-").map(Number);

  const monthChanged = py !== ny || pm !== nm;
  const daysInNewMonth = new Date(ny, nm, 0).getDate();

  // Month arrows keep the same day (or clamp it, e.g. 31 -> 30)
  const isArrowNavigation =
    monthChanged &&
    (pd === nd || (nd === daysInNewMonth && pd > daysInNewMonth));

  // Only the time was changed (same date as before)
  const isTimeOnly = prevDate && newDate === prevDate;

  // Close only when a date was actually clicked
  if (!isArrowNavigation && !isTimeOnly) {
    setTimeout(() => input.blur(), 0);
  }
};
 
  const formData = new FormData();

const handleSubmit = async (e) => {
  e.preventDefault();




  
  const selectedFile =
    document.getElementById("ReleaseSanctionCopy")?.files?.[0];

  const existingFile =
    data.ReleaseSanctionCopy ||
    projectDatainward?.ReleaseSanctionCopy ||
    projectDatainward?.releaseSanctionCopy;

  // ---------- VALIDATION (before loader) ----------
  const newErrors = {};

  if (!data.FinancialYear) newErrors.FinancialYear = "Financial Year is required";
  if (!data.ProjectID) newErrors.ProjectID = "Project Name is required";
  if (!data.ReleaseDate) newErrors.ReleaseDate = "Release Date is required";

  if (!data.Agency_Name || !data.Agency_Name.trim()) {
    newErrors.Agency_Name = "Implementing Agency is required";
  } else if (!data.Agency) {
    newErrors.Agency_Name = "Agency code not found for this agency";
  }

  if (!data.GRCopy) newErrors.GRCopy = "GR Copy is missing for this project";

  if (!selectedFile && !existingFile) {
    newErrors.ReleaseSanctionCopy = "Release Sanction Copy is required";
  }

  if (!isEdit) {
    if (!tableData || tableData.length === 0) {
      newErrors.ReleaseAmount =
        "Please enter Release Amount and click ADD before saving";
    }
  } else {
    const newAmt = Number(data.ReleaseAmount || 0);
    if (newAmt <= 0) {
      newErrors.ReleaseAmount = "Release Amount is required";
    } else if (newAmt > Number(data.RemainingAmount || 0)) {
      newErrors.ReleaseAmount = `Release Amount cannot exceed ₹${Number(
        data.RemainingAmount || 0,
      ).toLocaleString("en-IN")}`;
    }
  }

  if (Object.keys(newErrors).length > 0) {
    console.log("Validation errors:", newErrors);
    setErrors(newErrors);
    alert("Please fix:\n- " + Object.values(newErrors).join("\n- "));
    return;
  }

  setErrors({});
  setLoading(true);

  try {
    const formData = new FormData();

    // file (this was missing)
    if (selectedFile) {
      formData.append("ReleaseSanctionCopy", selectedFile);
    }

    if (!isEdit) {
      const syncedTableData = tableData.map((row) => ({
        ...row,
        Agency_Name: data.Agency_Name,
        Agency: data.Agency,
        AgencyName: data.Agency_Name,
        AgencyCode: data.Agency,
      }));

      const totalReleaseAmount = syncedTableData.reduce(
        (sum, row) => sum + Number(row.amount || row.ReleaseAmount || 0),
        0,
      );

      if (totalReleaseAmount <= 0) {
        alert("Total Release Amount must be greater than 0.");
        return; // finally will stop the loader
      }

      formData.append("tableData", JSON.stringify(syncedTableData));
      formData.append("TotalReleaseAmount", String(totalReleaseAmount));
      formData.append("type", "limit");
      formData.append("typeData", "createReleaseData");
    } else {
      formData.append("data", JSON.stringify(data));
      formData.append("ReleaseID", projectDatainward.ReleaseID);
      formData.append("typeData", "updateReleaseData");
    }

    for (const [key, value] of formData.entries()) {
      console.log(key, value);
    }

    const result = await ReleaseFDUTF(formData);
    console.log("ReleaseFDUTF result:", result);

    if (result?.message) {
      alert(result.message);
      window.location.reload();
    } else if (result?.error) {
      alert(result.error);
    } else {
      alert("Unexpected response from server.");
    }
  } catch (err) {
    console.error(err);
    alert("Something went wrong while saving.");
  } finally {
    setLoading(false);
  }
};
  // Fetching
  const FetchData = async () => {
    try {
      let res = await GetProjectInfo("null", "AgencyProjects");    
      setProjectId(res);
      setAllProjects(res);
      let res1 = await GetBudgetHeadInfo("null", "all");
      let res3 = await ViewAllReleaseFDUTF();
      // const res2 = await GetAgencyList();
      console.log("Tbale data ::", res3);
      // console.log("res 2----------",res2)
      console.log("All projects:", res);
      setAllProjects(res); // FOR THE YEAR WISE PROJECTS
      setProjectId(res); //uncommect on 22june fir budget head
      setHeadID(res1);
      console.log(
  "Fund rows:",
  res3.slice(0, 5).map((r) => ({
    ReleaseRowID: r.ReleaseRowID,
    ID: r.ID,
    ReleaseDate: r.ReleaseDate,
  }))
);
      // setAllTableData(res3);
      // 13-10 for sorting the fund list
      setAllTableData(
  [...(Array.isArray(res3) ? res3 : [])].sort(
     (a, b) => Number(b.ReleaseRowID || 0) - Number(a.ReleaseRowID || 0) //24-10
     
  )
  
);
      // setAgencyList(res2);
    } catch (err) {
      console.log(err);
    }
  };

  const HeadIDFetchOperation = async (ID, IDtype) => {
    try {
      console.log(ID);
      if (IDtype == "ProjectId") {
        let res1 = await GetProjectInfo(ID, "id");
        console.log("Project ID ingo :: ", res1);
        let projectData = res1[0];
        console.log("project data i sleected ", projectData);
        // let apple = [...new Map(HeadId.filter(item => item.ProjectName === projectData.ProjectName).map(item => [item.HeadName, item])).values()];
        // console.log("Head related to project ", apple)
        // setRelatedHeadID(apple);

        setData((prev) => ({
          ...prev,
          FinancialYear: projectData.FinancialYear,
          ProjectName: projectData.ProjectName,
          ProjectID: projectData.ProjectId,
          ReleaseAmountTillDate: projectData.ProjectCost,
          ProjectCost: projectData.ProjectCost,
          ReleaseAmount: projectData.ReleaseAmount,
          piu: projectData.PIU,
          UsedAmount: Number(projectData.UsedAmount || 0),
          RemainingAmount: Number(
            projectData.RemainingAmount ??
              Number(projectData.ProjectCost || 0) -
                Number(projectData.UsedAmount || 0),
          ),

          // Agency: projectData.Agency,
          GRCopy: projectData.GRCopy,
          // BudgetHeadID: apple.length > 0 ? apple[0].HeadID : "",
          // BudgetHeadName: apple.length > 0 ? apple[0].HeadName : ""
        }));
      } else if (IDtype == "HeadID") {
        let res1 = await GetBudgetHeadInfo(ID, "id");
        let HeadData = res1[0];
        setData((prev) => ({
          ...prev,
          BudgetHeadID: HeadData.HeadID,
          BudgetHeadName: HeadData.HeadName,
        }));
      }
    } catch (err) {
      console.log(err);
    }
  };

  const uniqueHeads = [];

  const filteredData = HeadId.filter((item) => {
    const isDuplicate = uniqueHeads.includes(item.HeadName);
    if (!isDuplicate) {
      uniqueHeads.push(item.HeadName);
      return true;
    }
    return false;
  });

  useEffect(() => {
    FetchData();
  }, []);

  useEffect(() => {
    if (data.FinancialYear) {
      const filtered = allProjects.filter(
        (p) => p.FinancialYear === data.FinancialYear,
      );
      setProjectId(filtered);
    } else {
      setProjectId(allProjects);
    }
    if (!isEdit) {
      setData((prev) => ({
        ...prev,
        ProjectID: "",
        ProjectName: "",
        BudgetHeadID: "",
        BudgetHeadName: "",
      }));
    }
  }, [data.FinancialYear, allProjects, isEdit]);

  const handleHeadChange = async (e) => {
    const headID = e.target.value;
    setData((prev) => ({
      ...prev,
      BudgetHeadID: headID,
      ProjectID: "",
      ProjectName: "",
    }));

    if (!headID || !data.FinancialYear) {
      setFilteredProjects([]);
      return;
    }

    try {
      const res = await GetProjectInfo(
        { HeadID: headID, FinancialYear: data.FinancialYear },
        "ProjectsByHeadAndYear",
      );
      console.log("Projects by Head & Year:", res);
      setFilteredProjects(res);
      // Set head name
      const head = HeadId.find((h) => h.HeadID == headID);
      if (head) {
        setData((prev) => ({ ...prev, BudgetHeadName: head.HeadName }));
      }
    } catch (err) {
      console.error(err);
    }
  };

  const AddinTableOperation = (e) => {
    e.preventDefault();
     if (isEdit) return;//07-10 for sendback
    const releaseAmount = Number(data.ReleaseAmount || 0);
    const EsitmateAmount = Number(data.EsitmateAmount || 0);
    const remainingAmount = Number(data.RemainingAmount || 0);
    const projectCost = Number(data.ProjectCost || 0);
    // Total amount already added in the table
    //------------------------------------22/08/2026
    // const tableTotal = tableData.reduce(
    //   (sum, item) => sum + Number(item.amount || 0),
    //   0,
    // );
    // const finalTotal = tableTotal + releaseAmount;
    // if (releaseAmount <= 0) {
    //   alert("Release Amount must be greater than 0.");
    //   return;
    // }
    // if (releaseAmount > projectCost) {
    //   alert(
    //     "Release Amount cannot be greater than Fund Allocation Amount & Project Cost.",
    //   );
    //   return;
    // }
    // if (EsitmateAmount > 0 && releaseAmount > EsitmateAmount) {
    //   alert("Release Amount cannot be greater than Estimate Cost.");
    //   return;
    // }

    // // -----------------------

    // // -------------

    // if (finalTotal > projectCost) {
    //   alert(
    //     `Total Release Amount cannot exceed Project Cost. ` +
    //       `Project Cost: ${projectCost} ` +
    //       `Already Added: ${tableTotal} ` +
    //       `Current Amount: ${releaseAmount} ` +
    //       `Remaining: ${projectCost - tableTotal}`,
    //   );
    //   return;
    // }
    if (!data.ProjectID) {
      alert("Please select a project.");
      return;
    }
    if (!data.Agency_Name || !data.Agency_Name.trim()) {
  alert("Please select an Implementing Agency before adding.");
  return;
}

    if (releaseAmount <= 0) {
      alert("Please enter a valid Release Amount.");
      return;
    }

    // ================================
    // IMPORTANT VALIDATION
    // Release Amount cannot exceed
    // Remaining Project Amount
    // ================================
    //    if (releaseAmount > remainingAmount) {
    //   alert(
    //     `Release Amount cannot be greater than Remaining Estimation Amount OR Estimate Amount.\n\n` +
    //       // `Project Cost: ₹${projectCost.toLocaleString("en-IN")}\n` +
    //       `Estimate Amount: ₹${EsitmateAmount.toLocaleString("en-IN")}\n` +
    //        `Release Amount: ₹${releaseAmount.toLocaleString("en-IN")}\n`+
    //       `Remaining Amount: ₹${remainingAmount.toLocaleString("en-IN")}`

    //   );

    //   return;
    // }

    // if (releaseAmount > EsitmateAmount) {
    //   alert(
    //     `Release Amount cannot be greater than Estimate Amount.\n\n` +
    //       `Estimate Amount: ₹${EsitmateAmount.toLocaleString("en-IN")}\n` +
    //       `Release Amount: ₹${releaseAmount.toLocaleString("en-IN")}`
    //   );

    //   return;
    // }
    // if (releaseAmount > remainingAmount) {
    //   alert(
    //     data.Scheme === "Budget"
    //       ? `Release Amount cannot be greater than Remaining Estimation Amount.\n\n` +
    //         `Estimate Amount: ₹${EsitmateAmount.toLocaleString("en-IN")}\n` +
    //         `Release Amount: ₹${releaseAmount.toLocaleString("en-IN")}\n` +
    //         `Remaining Estimation Amount: ₹${remainingAmount.toLocaleString("en-IN")}`
    //       : `Release Amount cannot be greater than Project Remaining Cost.\n\n` +
    //         `Project Cost: ₹${projectCost.toLocaleString("en-IN")}\n` +
    //         `Release Amount: ₹${releaseAmount.toLocaleString("en-IN")}\n` +
    //         `Project Remaining Cost: ₹${remainingAmount.toLocaleString("en-IN")}`
    //   );

    //   return;
    // }

    // if (releaseAmount > EsitmateAmount) {
    //   alert(
    //     `Release Amount cannot be greater than Estimate Amount.\n\n` +
    //       `Estimate Amount: ₹${EsitmateAmount.toLocaleString("en-IN")}\n` +
    //       `Release Amount: ₹${releaseAmount.toLocaleString("en-IN")}`
    //   );

    //   return;
    // }
    // ========================================
    // RELEASE AMOUNT VALIDATION
    // ========================================

    if (releaseAmount > remainingAmount) {
      if (data.Scheme === "Budget") {
        alert(
          `Release Amount cannot be greater than Remaining Estimation Amount.\n\n` +
            `Estimate Amount: ₹${EsitmateAmount.toLocaleString("en-IN")}\n` +
            `Release Amount: ₹${releaseAmount.toLocaleString("en-IN")}\n` +
            `Remaining Estimation Amount: ₹${remainingAmount.toLocaleString("en-IN")}`,
        );
      } else {
        alert(
          `Release Amount cannot be greater than Project Remaining Cost.\n\n` +
            `Project Cost: ₹${projectCost.toLocaleString("en-IN")}\n` +
            `Release Amount: ₹${releaseAmount.toLocaleString("en-IN")}\n` +
            `Project Remaining Cost: ₹${remainingAmount.toLocaleString("en-IN")}`,
        );
      }

      return;
    }

    // ========================================
    // ESTIMATE AMOUNT VALIDATION
    // ONLY FOR BUDGET PROJECTS
    // ========================================

    if (data.Scheme === "Budget" && releaseAmount > EsitmateAmount) {
      alert(
        `Release Amount cannot be greater than Estimate Amount.\n\n` +
          `Estimate Amount: ₹${EsitmateAmount.toLocaleString("en-IN")}\n` +
          `Release Amount: ₹${releaseAmount.toLocaleString("en-IN")}`,
      );

      return;
    }
    //----------------------------------------------------
    //   const obj = {
    //     projectId: data.ProjectID,
    //     projectName: data.ProjectName,
    //     year: data.FinancialYear,
    //     BudgetID: data.BudgetHeadID,
    //     BudgetHead: data.BudgetHeadName,
    //     Agency_Name: data.Agency_Name,
    //     piu: data.piu,
    //     Agency: data.Agency,
    //     ReleaseAmountTillDate: data.ProjectCost,
    //     amount: releaseAmount,
    //     currentDate: new Date().toISOString(),
    //     type: "limit",
    //     ReleaseAmount: releaseAmount,
    //   };
    //   setTableData((prev) => [...prev, obj]);
    //   setData((prev) => ({
    //     ...prev,
    //     ReleaseAmount: isEdit ? prev.ReleaseAmount : 0,
    //   }));
    // };
    //--------------------
    // ================================
    const newRow = {
      year: data.FinancialYear,
      ProjectID: data.ProjectID,
      projectName: data.ProjectName,
      amount: releaseAmount,
      currentDate: data.ReleaseDate,
      BudgetHeadID: data.BudgetHeadID || null,
      BudgetHead: data.BudgetHeadName || data.HeadName || "",

      AgencyName: data.Agency_Name || "",
      AgencyCode: data.Agency || "",
      Agency_Name: data.Agency_Name || "",
      Agency: data.Agency || "",
      piu: data.PIU|| "",
      type: "limit",
    };

    setTableData((prev) => [...prev, newRow]);

    // Reduce remaining amount immediately
    // for additional releases in this same form
    // setData((prev) => ({
    //   ...prev,
    //   ReleaseAmount: "",
    //   UsedAmount: Number(prev.UsedAmount || 0) + releaseAmount,
    //   RemainingAmount: Math.max(
    //     0,
    //     Number(prev.RemainingAmount || 0) - releaseAmount,
    //   ),
    // }));
    // 07-10 for sendback
    setData((prev) => ({
  ...prev,
  ReleaseAmount: isEdit ? prev.ReleaseAmount : "",
  UsedAmount: Number(prev.UsedAmount || 0) + releaseAmount,
  RemainingAmount: Math.max(0, Number(prev.RemainingAmount || 0) - releaseAmount),
}));
  };

  const handelchangeTablre = (e) => {
    e.preventDefault();
    const updatedData = [...tableData];
    updatedData[indexofediting] = editIndex;
    setTableData(updatedData);
    console.log("Editted Index :: ", editIndex);
    setData((prev) => ({
      ...prev,
      ReleaseAmount: editIndex.amount,
      RemainingAmount: editIndex.RemainingAmount,
    }));

    setEditIndex(null);
    setIndexofEditing(null);
  };
  const handleEdit = (e, index) => {
    e.preventDefault();
    const item = tableData[index];
    console.log("table i selected :: ", item);
    setEditIndex(item);
    setIndexofEditing(index);
  };

  const handleDelete = (e, index) => {
    e.preventDefault();
    const deletedAmount = Number(tableData[index]?.amount || 0);
    const updated = tableData.filter((_, i) => i !== index);
    setTableData(updated);
    setData((prev) => ({
      ...prev,
      UsedAmount: Math.max(0, Number(prev.UsedAmount || 0) - deletedAmount),
      RemainingAmount: Number(prev.RemainingAmount || 0) + deletedAmount,
    }));
  };
  // useEffect(() => {
  //     if (!data.Agency_Name) {
  //         setProjectId(allProjects);
  //         return;
  //     }

  //     const filteredProjects = allProjects.filter(
  //         (project) =>
  //             String(project.Agency_Name).trim() ===
  //             String(data.Agency_Name).trim()
  //     );

  //     console.log("Agency Wise Projects :", filteredProjects);

  //     setProjectId(filteredProjects);
  // }, [data.Agency_Name, allProjects]);

  useEffect(() => {
    if (!isEdit || !projectDatainward || projectId.length === 0) return;
    const selectedProject = projectId.find(
      (p) =>
        String(p.ProjectId || p.ProjectID || p.projectId) ===
          String(projectDatainward.ProjectID) ||
        p.ProjectName === projectDatainward.ProjectName,
    );
    console.log("selectedProject", selectedProject);

    if (!selectedProject) return;

    setData((prev) => ({
      ...prev,
      ReleaseID: projectDatainward.ReleaseID,
      FinancialYear: projectDatainward.FinancialYear || "",
      ProjectID: String(
        selectedProject.ProjectId ||
          selectedProject.ProjectID ||
          selectedProject.projectId,
      ),
      ProjectName: selectedProject.ProjectName,
      ProjectCost: selectedProject.ProjectCost,
      // Agency_Name: selectedProject.Agency_Name,
      // Agency: selectedProject.Unique_Agency_Code || selectedProject.AgencyCode,
// 08-10
      Agency_Name:
  projectDatainward.Agency_Name ||
  projectDatainward.AgencyName ||
  selectedProject.Agency_Name ||
  "",
Agency:
  projectDatainward.Agency ||
  projectDatainward.AgencyCode ||
  projectDatainward.Unique_Agency_Code ||
  selectedProject.Unique_Agency_Code ||
  selectedProject.AgencyCode ||
  "",

      GRCopy: selectedProject.GRCopy,
      BudgetHeadID: selectedProject.HeadID,
      BudgetHeadName: selectedProject.HeadName,
      // RemainingAmount: selectedProject.RemainingAmount,
      // 07-10 for sendback
      RemainingAmount:
  Number(selectedProject.RemainingAmount || 0) +
  Number(projectDatainward.ReleaseAmount || 0),

      //     ReleaseAmount: projectDatainward.ReleaseAmount,
      //     ReleaseDate: projectDatainward.ReleaseDate
      //       ? projectDatainward.ReleaseDate.slice(0, 16)
      //       : "",
      //   }));
      // }, [isEdit, projectDatainward, projectId]);
      ReleaseAmount: projectDatainward.ReleaseAmount,
      ReleaseDate: projectDatainward.ReleaseDate
        ? projectDatainward.ReleaseDate.slice(0, 16)
        : "",
      // Remark: projectDatainward.Remark || "",
      // ReleaseSanctionCopy: projectDatainward.ReleaseSanctionCopy || "",
      Remark: projectDatainward.Remark || projectDatainward.remark || "",
      ReleaseSanctionCopy:
        projectDatainward.ReleaseSanctionCopy ||
        projectDatainward.releaseSanctionCopy ||
        "",
    }));
  }, [isEdit, projectDatainward, projectId]);
  const resetForm = () => {
    setData({
      FinancialYear: "",
      ProjectName: "",
      ProjectID: "",
      ReleaseAmountTillDate: "",
      BudgetHeadID: "",
      BudgetHeadName: "",
      Agency_Name: "",
      Agency: "",
      ReleaseAmount: 0,
      ReleaseDate: "",
      ProjectCost: "",
      GRCopy: "",
      piu: "",
      Scheme: "",
      EsitmateAmount: 0,
    });
    setTableData([]);
    setEditIndex(null);
    setIndexofEditing(null);
    setFilteredProjects([]);
    setReleaseSanctionCopy(null);
  };

// 01/10 fetch agnecy
  useEffect(() => {
  const loadAgencies = async () => {
    try {
      if (typeof GetAgencyList !== "function") {
        console.error("GetAgencyList is missing from context");
        return;
      }
      const res = await GetAgencyList();
      console.log("AGENCY LIST =>", res);
      setAgencyList(Array.isArray(res) ? res : []);
    } catch (err) {
      console.error("Agency fetch failed:", err);
    }
  };
  loadAgencies();
}, []);


// 08-10
useEffect(() => {
  if (!isEdit || !data.Agency_Name || data.Agency || agencyList.length === 0) return;

  const match = agencyList.find(
    (item) =>
      String(item.Agency_Name || "").trim().toLowerCase() ===
      String(data.Agency_Name || "").trim().toLowerCase()
  );

  if (match) {
    setData((prev) => ({
      ...prev,
      Agency_Name: match.Agency_Name, // exact text so the <select> matches an option
      Agency:
        match.Unique_Agency_Code || match.AgencyCode || match.Agency_Code || "",
    }));
  }
}, [isEdit, data.Agency_Name, data.Agency, agencyList]);



// 08-10
const getPageNumbers = (currentPage, totalPages) => {
  const maxVisiblePages = 5;
 
  if (totalPages <= maxVisiblePages) {
    return Array.from({ length: totalPages }, (_, i) => i + 1);
  }
  if (currentPage <= 3) {
    return [1, 2, 3, 4, 5, "...", totalPages];
  }
  if (currentPage >= totalPages - 2) {
    return [
      "...",
      totalPages - 4,
      totalPages - 3,
      totalPages - 2,
      totalPages - 1,
      totalPages,
    ];
  }
  return [
    "...",
    currentPage - 2,
    currentPage - 1,
    currentPage,
    currentPage + 1,
    currentPage + 2,
    "...",
    totalPages,
  ];
};

const errorStyle = {
  color: "#dc3545",
  fontSize: "12px",
  marginTop: "4px",
  display: "block",
  fontWeight: "500",
};
 
 
  return (
    <>
      <div
        style={{
          background: "white",
          width: "100%",
          maxHeight: "91vh",
          transition: "margin-left 0.3s ease",
          overflowY: "auto",
          msOverflowStyle: "none",
          scrollbarWidth: "none",
          padding: "25px 20px",
          boxSizing: "border-box",
          fontFamily: "Inter, sans-serif",
        }}
      >
        {loading && (
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              background: "rgba(255, 255, 255, 0.7)",
              backdropFilter: "blur(4px)",
              zIndex: 9999,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <div
              style={{
                border: "6px solid #f3f3f3",
                borderTop: "6px solid #007bff",
                borderRadius: "50%",
                width: "60px",
                height: "60px",
                animation: "spin 1s linear infinite",
              }}
            />
            <style>{`@keyframes spin {0% { transform: rotate(0deg); }100% { transform: rotate(360deg); }}`}</style>
          </div>
        )}
        {/* HEADER */}
        <div
          style={{
            width: "100%",
            maxWidth: "1000px",
            margin: "0 auto 10px",
            display: "flex",
            alignItems: "center",
            gap: "8px",
            justifyContent: "center",
            marginBottom: "20px",
          }}
        >
          <img
            src={ProjectCreation64}
            alt="Budget Estimation"
            style={{
              width: "20px",
              height: "20px",
            }}
          />

          {/* <h5
            style={{
              margin: 0,
              fontSize: "20px",
              fontWeight: "700",
              color: "#111111",
            }}
          >
            Add Limit
          </h5> */}
          <h5
            style={{
              margin: 0,
              fontSize: "20px",
              fontWeight: "700",
              color: "#111111",
            }}
          >
            {isEdit ? "Update Limit" : "Add Limit"}
          </h5>
        </div>
<div style={{ backgroundColor: "#ffffff", borderRadius: "12px", boxShadow: "0 2px 12px rgba(0,0,0,0.08)", padding: "20px", maxWidth: "1000px", margin: "0 auto", width:"95%" }}>
        <form style={{
        backgroundColor: "#EEF2F8",
        border: "1px solid #dde3ee",
        borderRadius: "10px",
        padding: "25px 28px",
       
        gap: "18px 24px",
      }}>
          {/* FINANCIAL YEAR */}
          <div style={{ width: "100%" }}>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "stretch",
                width: "100%",
                marginBottom: "0",
              }}
            >
              <div style={{ width: "100%" }}>
                <label
                  style={{
  fontWeight: "700",
  fontSize: "14px",
  color: "#111111",
  marginBottom: "10px",
  paddingLeft: "0",
  textAlign: "left",
  display: "block",
}}
                >
                  Financial Year
                </label>

              </div>
              <div style={{ flex: 1 }}>
                <select
                  name="FinancialYear"
                  value={data.FinancialYear}
                  onChange={HandleChangeData}
                  style={{ border: "1px solid #c7c0c0",  borderRadius: "10px", padding: "7px 10px",  width: "100%",  height: "40px", backgroundColor: "#ffffff", fontFamily: "Inter, sans-serif", boxSizing: "border-box",outline: "none",fontSize: "12px"}}  >
                  <option value="">Choose Financial Year</option>
                  <option value="2024-2025">2024 - 2025</option>
                  <option value="2025-2026">2025 - 2026</option>
                  <option value="2026-2027">2026 - 2027</option>
                </select>

                {/* 08-10 */}
                {errors.FinancialYear && (
  <span style={errorStyle}>
    {errors.FinancialYear}
  </span>
)}
              </div>
            </div>
          </div>

          {/* BUDGET HEAD */}
          {/* <div style={{ marginLeft: '60px', width: '100%' }}>
            <div style={{ display: "flex", alignItems: "center", marginBottom: "20px", marginRight: "200px" }}>
              <div style={{ width: "200px" }}>
                <label style={{ fontWeight: "700", marginRight: "20px", paddingLeft: "30px", textAlign: "left" }}>Budget Head</label>
              </div>
              <div style={{ flex: 1 }}>
                <select name="BudgetHeadID" value={data.BudgetHeadID} onChange={handleHeadChange} style={{ border: "1px solid #ccc", borderRadius: "10px", padding: "10px", width: "100%", fontFamily: 'Inter, sans-serif' }}>
                  <option value="">Choose Budget Head</option>
                  {HeadId.map((val, index) => (
                    <option key={index} value={val.HeadID}>{val.CRC}/{val.HeadName}</option>
                  ))}
                </select>
              </div>
            </div>
          </div> */}

          {/* PROJECT NAME */}
          <div style={{ width: "100%" }}>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "stretch",
                width: "100%",
              }}
            >
              <div style={{ width: "200px" }}>
                <label
                  style={{
                    fontWeight: "700",
                    fontSize: "14px",
                    color: "#111111",
                    marginBottom: "10px",
                    paddingLeft: "0",
                    textAlign: "left",
                    display: "block",
                  }}
                >
                  Project Name
                </label>
              </div>
              <div style={{ flex: 1 }}>
               
                <Select
                  options={projectId.map((val) => ({
                    value: val.ProjectId || val.ProjectID,
                    label: val.ProjectName,
                  }))}
                  value={
                    projectId
                      .map((val) => ({
                        value: val.ProjectId || val.ProjectID,
                        label: val.ProjectName,
                      }))
                      .find(
                        (option) =>
                          String(option.value) === String(data.ProjectID),
                      ) || null
                  }
               
                  // 22-10
                  onChange={async (selectedOption) => {
  const projectID = selectedOption
    ? selectedOption.value
    : "";
 
  setErrors((prev) => ({
    ...prev,
    ProjectID: "",
  }));
 

                    if (!projectID) {
                      setData((prev) => ({
                        ...prev,
                        ProjectID: "",
                        ProjectName: "",
                        ProjectCost: 0,
                        UsedAmount: 0,
                        RemainingAmount: 0,
                        ReleaseAmount: 0,
                      }));
                      return;
                    }

                    try {
                      // ============================================
                      // FETCH LATEST PROJECT DATA
                      // ============================================
                      const projectResponse = await GetProjectInfo(
                        projectID,
                        "id",
                      );

                      console.log("LATEST PROJECT RESPONSE:", projectResponse);

                      if (
                        !Array.isArray(projectResponse) ||
                        projectResponse.length === 0
                      ) {
                        alert("Project details not found.");
                        return;
                      }

                      const selectedProject = projectResponse[0];


// ADD THIS 23-10
const codeOf = (a) =>
  a.Unique_Agency_Code || a.AgencyCode || a.Agency_Code || a.PIU || "";
const piuAgency = agencyList.find(
  (a) => String(codeOf(a)).trim() === String(selectedProject.PIU).trim()
);


                      // ============================================
                      // PROJECT COST
                      // ============================================
                      const projectCost = Number(
                        selectedProject.ProjectCost || 0,
                      );

                      // ============================================
                      // TOTAL RELEASE ALREADY SAVED IN DATABASE
                      // ============================================
                      // const dbReleaseAmount = Number(
                      //   selectedProject.ReleaseAmount || 0,
                      // );

                      // ============================================
                      // IF BACKEND RETURNS UsedAmount INSTEAD
                      // USE THE LARGER/CORRECT RELEASE VALUE
                      // ============================================
                      // const dbUsedAmount = Number(
                      //   selectedProject.UsedAmount || 0,
                      // );

                      // const alreadyUsedFromDB = Math.max(
                      //   dbReleaseAmount,
                      //   dbUsedAmount,
                      // );
                      //-------28-08

                      const alreadyUsedFromDB = Number(
                        selectedProject.ProjectUsedAmount || 0,
                      );

// 12-09  estimate amount
                      const totalEstimateAmount = Number(
  selectedProject.UsedAmount || 0,
);


                      // ============================================
                      // CURRENT UNSAVED RELEASES
                      // ============================================
                      const currentTableUsedAmount = tableData
                        .filter((item) => {
                          const itemProjectID =
                            item.ProjectID ||
                            item.ProjectId ||
                            item.projectID ||
                            item.projectId;

                          return String(itemProjectID) === String(projectID);
                        })
                        .reduce(
                          (sum, item) => sum + Number(item.amount || 0),
                          0,
                        );

                      // ============================================
                      // FINAL USED AMOUNT
                      // ============================================
                      const totalUsedAmount =
                        alreadyUsedFromDB + currentTableUsedAmount;


                        const baseAmountForRemaining =
  selectedProject.Scheme === "Budget"
    ? totalEstimateAmount
    : projectCost;
                      // ============================================
                      // FINAL REMAINING AMOUNT
                      // ============================================
                      // const remainingAmount = Math.max(
                      //   0,
                      //   projectCost - totalUsedAmount,
                      // );
                      const remainingAmount = Math.max(
  0,
  baseAmountForRemaining - totalUsedAmount,
);

                      console.log("====================================");
                      console.log("PROJECT ID:", projectID);
                      console.log("PROJECT COST:", projectCost);
                      console.log("ALREADY USED (from DB):", alreadyUsedFromDB);
                      console.log(
                        "CURRENT UNSAVED AMOUNT:",
                        currentTableUsedAmount,
                      );
                      console.log("TOTAL USED:", totalUsedAmount);
                      console.log("FINAL REMAINING:", remainingAmount);
                      console.log("====================================");
                      // ============================================
                      // UPDATE FORM
                      // ============================================
                      setData((prev) => ({
                        ...prev,

                        ProjectID:
                          selectedProject.ProjectId ||
                          selectedProject.ProjectID ||
                          projectID,

                        ProjectName: selectedProject.ProjectName || "",

                        FinancialYear: selectedProject.FinancialYear || "",

                        ProjectCost: projectCost,

                        UsedAmount: totalUsedAmount,

                        RemainingAmount: remainingAmount,

                        piu: selectedProject.PIU || selectedProject.piu || "",

                        // 23-10 
                        Agency_Name: piuAgency?.Agency_Name || selectedProject.Agency_Name || prev.Agency_Name || "",
                         Agency: selectedProject.PIU || prev.Agency || "",
// --------------

                        GRCopy: selectedProject.GRCopy || "",

                        BudgetHeadID:
                          selectedProject.BudgetHeadID ||
                          selectedProject.HeadID ||
                          "",

                        BudgetHeadName:
                          selectedProject.BudgetHeadName ||
                          selectedProject.BudgetHead ||
                          selectedProject.HeadName ||
                          "",

                        Scheme: selectedProject.Scheme || "",

                        HeadName:
                          selectedProject.BudgetHead ||
                          selectedProject.BudgetHeadName ||
                          selectedProject.HeadName ||
                          "",

                        // EsitmateAmount: Number(
                        //   selectedProject.totalEstimateAmount || 0,
                        // ),
                        EsitmateAmount: totalEstimateAmount,

                        ReleaseAmount: 0,
                      }));
                    } catch (error) {
                      console.error("Error fetching project details:", error);

                      alert("Unable to fetch project details.");
                    }
                  }}
                  placeholder="Search or select project..."
                  isSearchable
                  isClearable
                  noOptionsMessage={() => "No project found"}
                  styles={{
                    control: (base) => ({
                      ...base,
                      minHeight: "40px",
                      height: "40px",
                      borderRadius: "10px",
                      borderColor: "#c7c0c0",
                      boxShadow: "none",
                      fontFamily: "Inter, sans-serif",
                    }),
                    singleValue: (base) => ({
                      ...base,
                      fontSize: "12px",
                    }),
                    input: (base) => ({
                      ...base,
                      fontSize: "12px",
                    }),
                    placeholder: (base) => ({
                      ...base,
                      fontSize: "12px",
                    }),
                  }}
                />


                {/* 08-10 */}
                 {errors.ProjectID && (
  <span style={errorStyle}>
    {errors.ProjectID}
  </span>
)}
 
              </div>
            </div>
          </div>
    
          {/* ----Head Name-- */}
          {data.Scheme === "Budget" && (
            <div style={{ width: "100%" }}>
              <div
                style={{
                  display: "flex",
                  width: "100%",
                  flexDirection: "column",
                }}
              >
                <div style={{ width: "100%" }}>
                  <label
                    style={{
                      fontWeight: "700",
                      fontSize: "14px",
                      color: "#111111",
                      marginBottom: "10px",
                      paddingLeft: "0",
                      textAlign: "left",
                      display: "block",
                    }}
                  >
                    Head Name
                  </label>
                </div>
                <div style={{ flex: 1 }}>
                  <input
                    type="text"
                    value={data.HeadName || ""}
                    readOnly
                    style={{
                      border: "1px solid #ccc",
                      borderRadius: "10px",
                      padding: "10px",
                      width: "100%",
                      backgroundColor: "#f3f3f3",
                      opacity: "1",
                      color: "#777",
                      fontSize: "12px",
                    }}
                  />
                </div>
              </div>
            </div>
          )}

          {/* ----Estimate Amount-- */}
          {data.Scheme === "Budget" && (
            <div style={{ width: "100%" }}>
              <div
                style={{
                  display: "flex",
                  width: "100%",
                  flexDirection: "column",
                }}
              >
                <div style={{ width: "100%" }}>
                  <label
                    style={{
                      fontWeight: "700",
                      fontSize: "14px",
                      color: "#111111",
                      marginBottom: "10px",
                      paddingLeft: "0",
                      textAlign: "left",
                      display: "block",
                    }}
                  >
                    Estimate Amount
                  </label>
                </div>
                <div style={{ flex: 1 }}>
                  <input
                    type="text"
                    value={Number(data.EsitmateAmount || 0).toLocaleString(
                      "en-IN",
                    )}
                    readOnly
                    style={{
                      border: "1px solid #ccc",
                      borderRadius: "10px",
                      padding: "10px",
                      width: "100%",
                      backgroundColor: "#f3f3f3",
                      opacity: "1",
                      color: "#777",
                      fontSize: "12px",
                    }}
                  />
                </div>
              </div>
            </div>
          )}

          {/* PROJECT COST */}
          <div style={{ width: "100%" }}>
            <div
              style={{
                display: "flex",
                width: "100%",
                flexDirection: "column",
              }}
            >
              <div style={{ width: "200px" }}>
                <label
                  style={{
                    fontWeight: "700",
                    fontSize: "14px",
                    color: "#111111",
                    marginBottom: "10px",
                    paddingLeft: "0",
                    textAlign: "left",
                    display: "block",
                  }}
                >
                  Project Cost
                </label>
              </div>
              <div style={{ flex: 1 }}>
                <input
                  type="text"
                  // value={data.ProjectCost || "0"}
                  value={Number(data.ProjectCost || 0).toLocaleString("en-IN")}
                  readOnly
                  style={{ border: "1px solid #c7c0c0",  borderRadius: "10px", padding: "7px 10px",  width: "100%",  height: "40px", backgroundColor: "#ffffff", fontFamily: "Inter, sans-serif", boxSizing: "border-box",outline: "none",fontSize: "12px"}}/>
              </div>
            </div>
          </div>
          {/* REMAINING PROJECT AMOUNT */}
          <div style={{ width: "100%" }}>
            <div
              style={{
                display: "flex",
                width: "100%",
                flexDirection: "column",
              }}
            >
              <div style={{ width: "100%" }}>
                <label
                  style={{
                    fontWeight: "700",
                    fontSize: "14px",
                    color: "#111111",
                    marginBottom: "10px",
                    paddingLeft: "0",
                    textAlign: "left",
                    display: "block",
                  }}
                >
                  {/* Remaining Estimation Amount */}
                  {data.Scheme === "Budget"
                    ? "Remaining Estimation Amount"
                    : "Project Remaining Cost"}
                </label>
              </div>

              <div style={{ flex: 1 }}>
                <input
                  type="text"
                  value={Number(data.RemainingAmount || 0).toLocaleString(
                    "en-IN",
                  )}
                  readOnly
                  style={{ border: "1px solid #c7c0c0",  borderRadius: "10px", padding: "7px 10px",  width: "100%",  height: "40px", backgroundColor: "#ffffff", fontFamily: "Inter, sans-serif", boxSizing: "border-box",outline: "none",fontSize: "12px"}}/>
              </div>
            </div>
          </div>

          {/* PIU */}
          <div style={{ width: "100%" }}>
            <div
              style={{
                display: "flex",
                width: "100%",
                flexDirection: "column",
              }}
            >
              <div style={{ width: "100%" }}>
                <label
                  style={{
                    fontWeight: "700",
                    fontSize: "14px",
                    color: "#111111",
                    marginBottom: "10px",
                    paddingLeft: "0",
                    textAlign: "left",
                    display: "block",
                  }}
                >
                  Implementing Agency
                </label>
              </div>
              <div style={{ flex: 1 }}>
                <select
                  name="Agency_Name"
                  value={data.Agency_Name}
                  required
                 // 22-10
                  onChange={(e) => {
  const agencyName = e.target.value;
 
  setErrors((prev) => ({
    ...prev,
    Agency_Name: "",
  }));
                    const selectedAgency = agencyList.find(
                      (item) =>
                        String(item.Agency_Name || "")
                          .trim()
                          .toLowerCase() ===
                        String(agencyName || "")
                          .trim()
                          .toLowerCase(),
                    );
                 

                    const agencyCode = selectedAgency
                      ? selectedAgency.Unique_Agency_Code ||
                        selectedAgency.AgencyCode ||
                        selectedAgency.Agency_Code ||
                        ""
                      : "";

                    console.log("Selected Agency Name:", agencyName);
                    console.log("Matched Agency Object:", selectedAgency);
                    console.log("Final Agency Code:", agencyCode);

                    setData((prev) => ({
                      ...prev,
                      Agency_Name: agencyName,
                      Agency: agencyCode,
                    }));
                  }}
                  style={{ border: "1px solid #c7c0c0",  borderRadius: "10px", padding: "7px 10px",  width: "100%",  height: "40px", backgroundColor: "#ffffff", fontFamily: "Inter, sans-serif", boxSizing: "border-box",outline: "none",fontSize: "12px"}} >
                  <option value="">Select Agency</option>
                  {agencyList.map((item) => (
                    <option key={item.AgencyID} value={item.Agency_Name}>
                      {" "}
                      {item.Agency_Name}
                    </option>
                  ))}
                </select>
                {errors.Agency_Name && (
  <span style={errorStyle}>
    {errors.Agency_Name}
  </span>
)}
              </div>
            </div>
          </div>

          {/* GR COPY */}
          
          <div style={{ width: "100%" }}>
  <div style={{ display: "flex", flexDirection: "column", width: "100%" }}>
    <div style={{ width: "100%" }}>
      <label style={{ fontWeight: "700", fontSize: "14px", color: "#111111", marginBottom: "10px", paddingLeft: "0", textAlign: "left", display: "block" }}>
        GR Copy
      </label>
    </div>
 
   
    <div style={{ flex: 1 }}>
      <div style={{ border: "1px solid #c7c0c0",  borderRadius: "10px", padding: "7px 10px",  width: "100%",  height: "40px", backgroundColor: "#ffffff", fontFamily: "Inter, sans-serif", boxSizing: "border-box",outline: "none",fontSize: "12px"}}>
        {data.GRCopy ? (
          <a href={`${apiurl}/ProjectDocsImages/${data.GRCopy}`} target="_blank" rel="noreferrer" title={data.GRCopy} style={{ color: "#2ea4e7", textDecoration: "underline", display: "inline-block", maxWidth: "100%", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
            {data.GRCopy}
          </a>
        ) : (
          <span style={{ color: "#d9534f", fontWeight: 700 }}>--</span>
        )}
      </div>
    </div>
  </div>
</div>
 

          {/* RELEASE DATE */}
          <div style={{ width: "100%" }}>
            <div
              style={{
                display: "flex",
                width: "100%",
                flexDirection: "column",
              }}
            >
              <div style={{ width: "100%" }}>
                <label
                  style={{
                    fontWeight: "700",
                    fontSize: "14px",
                    color: "#111111",
                    marginBottom: "10px",
                    paddingLeft: "0",
                    textAlign: "left",
                    display: "block",
                  }}
                >
                  Release Date
                </label>
              </div>
              <div style={{ flex: 1 }}>
                {/* 27-10 */}
               <input
  ref={releaseDateRef}
  type="datetime-local"
  name="ReleaseDate"
  value={(data.ReleaseDate || "").slice(0, 16)}
  min={minDateTime}
  max="9999-12-31T23:59"
  onChange={handleReleaseDateChange}
  style={{
    border: "1px solid #c8c8c8",
    borderRadius: "8px",
    padding: "10px 14px",
    width: "100%",
    height: "42px",
    backgroundColor: "#ffffff",
    fontFamily: "Inter, sans-serif",
    boxSizing: "border-box",
    outline: "none",
    fontSize: "13px",
  }}
/>
 {errors.ReleaseDate && (
  <span style={errorStyle}>
    {errors.ReleaseDate}
  </span>
)}
              </div>
            </div>
          </div>

          {/* RELEASE SANCTION COPY */}
          <div
            style={{
              width: "100%",
            }}
          >
            <div
              style={{
                display: "flex",
                width: "100%",
                flexDirection: "column",
              }}
            >
              <div style={{ width: "100%" }}>
                <label
                  style={{
                    fontWeight: "700",
                    fontSize: "14px",
                    color: "#111111",
                    marginBottom: "10px",
                    paddingLeft: "0",
                    textAlign: "left",
                    display: "block",
                  }}
                >
                  Release Sanction Copy Upload*
                </label>
              </div>
              {/* <div style={{ flex: 1 }}>
                <input
                  type="file"
                  id="ReleaseSanctionCopy"
                  name="ReleaseSanctionCopy"
                  required
                  onChange={(e) => {
                    const file = e.target.files[0];
                    if (!file) {
                      setReleaseSanctionCopy(null);
                      return;
                    }
                    setReleaseSanctionCopy(file);
                  }}
                  style={{
                    border: "1px solid #ccc",
                    borderRadius: "10px",
                    padding: "10px",
                    width: "100%",
                    backgroundColor: "#f3f3f3",
                    opacity: "1",
                    color: "#777",
                    fontSize: "13px",
                  }}
                />
              </div> */}
              <div style={{ flex: 1 }}>
                {isEdit && data.ReleaseSanctionCopy && (
                  <p
                    style={{
                      fontSize: "12px",
                      color: "#555",
                      marginBottom: "6px",
                    }}
                  >
                    Current file: {data.ReleaseSanctionCopy}
                  </p>
                )}
                <input
                  type="file"
                  id="ReleaseSanctionCopy"
                  name="ReleaseSanctionCopy"
                  required={!isEdit}
                          // 22-10
                  onChange={(e) => {
  const file = e.target.files[0];
 
  if (!file) {
    setReleaseSanctionCopy(null);
    return;
  }
 
  setReleaseSanctionCopy(file);
 
  setData((prev) => ({
    ...prev,
    ReleaseSanctionCopy: file,
  }));
 
  setErrors((prev) => ({
    ...prev,
    ReleaseSanctionCopy: "",
  }));
}}
                  style={{
                    border: "1px solid #ccc",
                    borderRadius: "10px",
                    padding: "10px",
                    width: "100%",
                    backgroundColor: "#f3f3f3",
                    opacity: "1",
                    color: "#777",
                    fontSize: "13px",
                  }}
                />
                 {errors.ReleaseSanctionCopy && (
  <span style={errorStyle}>
    {errors.ReleaseSanctionCopy}
  </span>
)}

              </div>
            </div>
          </div>

          {/* RELEASE AMOUNT WITH ADD BUTTON */}
          <div
            style={{
              gridColumn: "1 / -1",
              width: "100%",
            }}
          >
            <div
              style={{
                display: "flex",
                width: "100%",
                flexDirection: "column",
              }}
            >
              <div style={{ width: "100%" }}>
                <label
                  style={{
                    fontWeight: "700",
                    fontSize: "14px",
                    color: "#111111",
                    marginBottom: "10px",
                    paddingLeft: "0",
                    textAlign: "left",
                    display: "block",
                  }}
                >
                  Release Amount
                </label>
              </div>
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  gap: "10px",
                  alignItems: "center",
                }}
              >
                <input
                  type="text"
                  placeholder="Enter Release Amount"
                  name="ReleaseAmount"
                  // value={data.ReleaseAmount}
                  value={
                    data.ReleaseAmount !== null &&
                    data.ReleaseAmount !== undefined &&
                    data.ReleaseAmount !== ""
                      ? Number(data.ReleaseAmount).toLocaleString("en-IN")
                      : ""
                  }
                  //  onChange={HandleChangeData}
                  onChange={(e) => {
                    const rawValue = e.target.value.replace(/,/g, "");

                    if (rawValue === "" || /^\d*\.?\d*$/.test(rawValue)) {
                      HandleChangeData({
                        target: {
                          name: "ReleaseAmount",
                          value: rawValue,
                        },
                      });
                    }
                  }}
                 style={{ border: "1px solid #c7c0c0",  borderRadius: "10px", padding: "7px 10px",  width: "100%",  height: "40px", backgroundColor: "#ffffff", fontFamily: "Inter, sans-serif", boxSizing: "border-box",outline: "none",fontSize: "12px"}}  />
                  {errors.ReleaseAmount && (
  <span style={errorStyle}>
    {errors.ReleaseAmount}
  </span>
)}
{!isEdit && (
                <button
                  type="button"
                  onClick={AddinTableOperation}
                  style={{
                    background:
                      "linear-gradient(to bottom, #044c92, #0071bc, #022f5a)",
                    color: "white",
                    border: "none",
                    borderRadius: "10px",
                    padding: "10px 20px",
                    fontWeight: "600",
                    cursor: "pointer",
                    whiteSpace: "nowrap",
                    fontSize: "1rem",
                  }}
                >
                  <img
                    src={Add32}
                    style={{ marginRight: "20px", width: "1.5rem" }}
                  />
                  ADD
                </button>
)}
              </div>
            </div>
          </div>

          {/* EDIT MODAL */}
          {editIndex && (
            <div
              style={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                background: "rgba(0, 0, 0, 0.5)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                zIndex: 1000,
              }}
            >
              <div
                style={{
                  background: "white",
                  borderRadius: "16px",
                  padding: "35px",
                  maxWidth: "450px",
                  width: "90%",
                  boxShadow: "0 10px 40px rgba(0, 0, 0, 0.2)",
                }}
              >
                <h4
                  style={{
                    marginBottom: "25px",
                    fontSize: "20px",
                    fontWeight: "700",
                    color: "#044c92",
                    textAlign: "center",
                  }}
                >
                  Edit Release{" "}
                </h4>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "20px",
                  }}
                >
                   {data.Scheme === "Budget" && (
                  <div>
                    <label
                      style={{
                        fontWeight: "700",
                        fontSize: "14px",
                        color: "#333",
                        marginBottom: "10px",
                        display: "block",
                      }}
                    >
                      Budget Head{" "}
                    </label>
                    <input
                      type="text"
                      value={editIndex.BudgetHead}
                      disabled
                      style={{
                        padding: "12px 14px",
                        border: "1.5px solid #d0d8e8",
                        borderRadius: "8px",
                        width: "100%",
                        backgroundColor: "#f5f5f5",
                      }}
                    />
                  </div>
                   )}
                  <div>
                    <label
                      style={{
                        fontWeight: "700",
                        fontSize: "14px",
                        color: "#333",
                        marginBottom: "10px",
                        display: "block",
                      }}
                    >
                      {" "}
                      Release Amount{" "}
                    </label>
                    {/* <input
                      type="number"
                      value={editIndex.amount}
                      name="amount"
                      onChange={(e) =>
                        setEditIndex({ ...editIndex, amount: e.target.value })
                      }
                      style={{
                        padding: "12px 14px",
                        border: "1.5px solid #d0d8e8",
                        borderRadius: "8px",
                        width: "100%",
                      }}
                    /> */}
                       {/* 13-10 */}
                     <input
    type="text"
    value={
      editIndex.amount !== "" && editIndex.amount != null
        ? Number(editIndex.amount).toLocaleString("en-IN")
        : ""
    }
    name="amount"
    onChange={(e) => {
      const value = e.target.value.replace(/,/g, "");

      if (/^\d*\.?\d*$/.test(value)) {
        setEditIndex({
          ...editIndex,
          amount: value,
        });
      }
    }}
    style={{
      padding: "12px 14px",
      border: "1.5px solid #d0d8e8",
      borderRadius: "8px",
      width: "100%",
    }}
  />
                  </div>

                  <div
                    style={{ display: "flex", gap: "12px", marginTop: "15px" }}
                  >
                    <button
                      onClick={handelchangeTablre}
                      style={{
                        flex: 1,
                        padding: "12px",
                        background:
                          "linear-gradient(135deg, #28a745 0%, #20c997 100%)",
                        color: "white",
                        border: "none",
                        borderRadius: "8px",
                        fontWeight: "600",
                        cursor: "pointer",
                      }}
                    >
                      Submit
                    </button>
                    <button
                    
                      onClick={() => {
                        setEditIndex(null);
                        setIndexofEditing(null);
                      }}
                      style={{
                        flex: 1,
                        padding: "12px",
                        background:
                          "linear-gradient(135deg, #dc3545 0%, #e74c3c 100%)",
                        color: "white",
                        border: "none",
                        borderRadius: "8px",
                        fontWeight: "600",
                        cursor: "pointer",
                      }}
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* TABLE DATA */}
          {tableData && tableData.length > 0 && (
            <div
              style={{
                // border:"1px solid red",
                // marginRight: "60px",
                overflowX: "auto",
                display: "flex",
                // justifyContent: "center",
                width: "100%",
                marginTop: "30px",
              }}
            >
              <table
                style={{
                  // border:"1px solid red",
                  backgroundColor: "white",
                  width: "95%",
                  maxWidth: "1000px",
                  borderCollapse: "collapse",
                  boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                  borderRadius: "8px",
                  overflow: "hidden",
                }}
              >
                <thead>
                  <tr
                    style={{
                      backgroundColor: "#E5EBF8",
                      color: "Black",
                      fontSize: 13,
                      fontWeight: 600,
                      textAlign: "center",
                      whiteSpace: "nowrap",
                    }}
                  >
                    <th style={{ padding: 10 }}>Year</th>
                    {/* <th style={{ padding: 10 }}>Budget Head</th> */}
                    <th style={{ padding: 10 }}>Project Name</th>
                    <th style={{ padding: 10 }}>Amount</th>
                    <th style={{ padding: 10 }}>Date</th>
                    <th style={{ padding: 10 }}>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {tableData.map((val, index) => (
                    <tr
                      key={index}
                      style={{
                        backgroundColor: index % 2 === 0 ? "#f4f7fe" : "white",
                        fontSize: 15,
                        fontWeight: 600,
                        textAlign: "center",
                      }}
                    >
                      <td style={{ padding: 10 }}>{val.year}</td>
                      {/* <td style={{ padding: 10, textAlign: 'left' }}>{val.BudgetHead}</td> */}
                      <td style={{ padding: 10, textAlign: "center" }}>
                        {val.projectName}
                      </td>
                      <td style={{ padding: 10 }}>
                        {Number(val.amount).toLocaleString("en-IN")}
                      </td>
                      <td style={{ padding: 10 }}>
                        {new Date(val.currentDate).toLocaleDateString("en-IN")}
                      </td>
                      <td
                        style={{
                          padding: "10px",
                          display: "flex",
                          justifyContent: "center",
                          gap: "8px",
                        }}
                      >
                        <button
                          onClick={(e) => handleEdit(e, index)}
                          style={{
                            backgroundColor: "#2ea4e7",
                            color: "white",
                            border: "none",
                            borderRadius: "5px",
                            padding: "5px 10px",
                            fontWeight: "600",
                            fontSize: "12px",
                            cursor: "pointer",
                          }}
                        >
                          Edit
                        </button>
                        <button
                          onClick={(e) => handleDelete(e, index)}
                          style={{
                            backgroundColor: "#dc3545",
                            color: "white",
                            border: "none",
                            borderRadius: "5px",
                            padding: "5px 10px",
                            fontWeight: "600",
                            fontSize: "12px",
                            cursor: "pointer",
                          }}
                        >
                          Delete
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </form>
        </div>
        {/* SUBMIT & CANCEL BUTTONS */}
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            gap: "20px",
            marginTop: "30px",
            width: "100%",
          }}
        >
          <button
            onClick={handleSubmit}
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              borderRadius: "20px",
              width: "120px",
              height: "40px",
              backgroundColor: "#39b54a",
              border: "none",
              fontSize: "16px",
              color: "#ffffff",
              fontWeight: "700",
              cursor: "pointer",
            }}
          >
            <img
              src={submit}
              style={{
                marginRight: "10px",
                width: "1.2rem",
                paddingBottom: "3px",
                fontSize: "15px",
              }}
            />{" "}
            {projectDatainward ? "Update" : "Save"}
          </button>
          <button
          onClick={() => {
  resetForm();
  alert("Cancel successfully.");
}}  
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              borderRadius: "20px",
              width: "120px",
              height: "40px",
              backgroundColor: "#f03c2c",
              // opacity: "0.6",
              border: "none",
              fontSize: "16px",
              color: "#ffffff",
              fontWeight: "700",
              cursor: "pointer",
            }}
          >
            <img
              src={Cancel32}
              style={{ marginRight: "10px", width: "1.2rem" }}
            />{" "}
            Cancel
          </button>
        </div>

       {/* ALL RELEASES TABLE */}
        {AlltableData && AlltableData.length > 0 && (
          <div     style={{
    width: "100%",
    backgroundColor: "#EEF1F6",
    borderRadius: "8px",
    padding: "25px 28px 28px",
    boxSizing: "border-box",
    border: "1px solid #b8dcff",
    marginTop:"20px"
  }}
          >
            <div   style={{
    backgroundColor: "#ffffff",
    padding: "20px",
    borderRadius: "8px",
    width: "100%",
    boxSizing: "border-box",
    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.12)",
  }}      >
            
           {/* //24/10 */}
<div
  style={{
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
    marginBottom: "12px",
    padding: "0 6px",
    boxSizing: "border-box",
  }}
>
  {/* Left Side: Icon + Heading */}
  <div
    style={{
      display: "flex",
      alignItems: "center",
      gap: "10px",
    }}
  >
    {/* Existing Fund List icon yahan rakho */}
 <img
                  src={"/List-32.png"}
                  alt="Project Icon"
                  style={{ marginRight: "10px", width: 28, height: 28 }}
                />
    <h5
      style={{
        margin: 0,
        fontSize: "16px",
        fontWeight: "600",
        color: "#111",
      }}
    >
      Fund List
    </h5>
  </div>

{/* //24/10 */}
  {/* Right Side: Search Input */}
 <div style={{ position: "relative", width: "230px" }}>
  <img
    src="/Search-32.png"
    alt="Search"
    style={{
      position: "absolute",
      left: "12px",
      top: "50%",
      transform: "translateY(-50%)", width: "16px", height: "16px", objectFit: "contain", zIndex: 2, pointerEvents: "none" }}/>

  <input
    type="text"
    placeholder="Search all fund records..."
    value={fundSearchTerm}
    onChange={(e) => setFundSearchTerm(e.target.value)}
    style={{
      width: "100%",
      height: "36px",
      padding: "8px 12px 8px 35px",
      border: "1px solid #c7d2e5",
      borderRadius: "8px",
      boxSizing: "border-box",
      fontSize: "12px",
      outline: "none",
      backgroundColor: "#fff"
    }}
  />
</div></div>


               <div  style={{ maxHeight: "300px", overflowY: "auto", overflowX: "auto", border: "1px solid #e6e9ee", borderRadius: "10px", position: "relative" }} >

              <table
                style={{ width: "100%", borderCollapse: "separate",  borderSpacing: 0 }}
              >
                <thead>
                  <tr
                     style={{
                      backgroundColor: "#2D79D9",
                         color: "white",
                       fontSize:"14px",
                      fontWeight: 500,
                      textAlign: "center",
                      whiteSpace: "nowrap",
                    }}
                  >
                    <th style={{ padding: 12, textAlign: "center" }}>Sr No</th>
                    <th style={{ padding: 12, textAlign: "center" }}>
                      Financial Year
                    </th>
                    <th style={{ padding: 12, textAlign: "center" }}>
                      Project Name
                    </th>
                    <th style={{ padding: 12, textAlign: "center" }}>
                      Project Cost
                    </th>
                    <th style={{ padding: 12, textAlign: "center" }}>
                      Release Amount
                    </th>
                    <th style={{ padding: 12, textAlign: "center" }}>
                      Release Date
                    </th>
                  </tr>
                </thead>
                <tbody>
{/* 24-10 */}
{currentFundTableData.length === 0 ? (
    <tr>
      <td
        colSpan={6}
        style={{
          padding: "30px 12px",
          textAlign: "center",
          fontSize: "14px",
          fontWeight: 600,
          color: "#dc3545",
          backgroundColor: "white",
        }}
      >
        No limit Found
      </td>
    </tr>
  ) : (

                  currentFundTableData.map((val, index) => (
                    <tr
                      key={index}
                     style={{
                        //30/10
                        backgroundColor: index % 2 === 0 ? "#E5F4FB" : "#CEE4F1",
                        fontSize: 13,
                        fontWeight: 500,
                        textAlign: "center",
                        borderBottom: "1px solid #d1d5db",
                      }}
                    >
                      {/* <td style={{ padding: 12 }}>{index + 1}</td> */}
                      {/* 08-10 add paginatiom */}
                <td style={{ padding: 12 }}>
          {fundStartIndex + index + 1}
        </td>
 
 
                      <td style={{ padding: 12 }}>{val.FinancialYear}</td>
                      <td
                        style={{
                          padding: 12,
                          textAlign: "center",
                          paddingLeft: "15px",
                        }}
                      >
                        {val.ProjectName}
                      </td>
                      <td style={{ padding: 12 }}>
                        {Number(val.ProjectCost).toLocaleString(
                          "en-IN",
                        )}
                      </td>
                      <td
                        style={{
                          padding: 12,
                          color: "green",
                          fontWeight: "600",
                        }}
                      >
                        {Number(val.ReleaseAmount).toLocaleString("en-IN")}
                      </td>
                      <td style={{ padding: 12 }}>
                        {new Date(val.ReleaseDate).toLocaleDateString("en-IN")}
                      </td>
                    </tr>
                  ))
                )}
                </tbody>
              </table>
              </div>
                  {/* 08-10 pagination */}
                     {/* FUND LIST PAGINATION */}
                     {/* 24-10 */}
{filteredFundTableData.length> 0 && (
  <div
    style={{
      width: "100%",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      marginTop: "15px",
      padding: "10px 5px",
      boxSizing: "border-box",
    }}
  >
    {/* Showing */}
    <div
      style={{
        fontSize: "13px",
        color: "#333",
        whiteSpace: "nowrap",
      }}
    >
      Showing{" "}
      {filteredFundTableData.length === 0
        ? 0
        : fundStartIndex + 1}{" "}
      to{" "}
      {Math.min(
        fundStartIndex + fundItemsPerPage,
       filteredFundTableData.length
      )}{" "}
      of {filteredFundTableData.length} entries
    </div>
 
    {/* Pagination */}
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: "18px",
      }}
    >
      {/* Previous */}
      <button
        onClick={() =>
          setFundCurrentPage((prev) =>
            Math.max(prev - 1, 1)
          )
        }
        disabled={fundCurrentPage === 1}
        style={{
          border: "none",
          background: "transparent",
          color:
            fundCurrentPage === 1
              ? "#999"
              : "#2ea4e7",
          cursor:
            fundCurrentPage === 1
              ? "not-allowed"
              : "pointer",
          fontSize: "13px",
          padding: 0,
          display: "flex",
          alignItems: "center",
          gap: "4px",
          opacity:
            fundCurrentPage === 1 ? 0.5 : 1,
        }}
      >
        <span style={{ fontSize: "20px" }}>‹</span>
        Previous
      </button>
 
      {/* Page Numbers */}
{/* //8/10 */}
{getPageNumbers(fundCurrentPage, fundTotalPages).map(
  (pageNumber, index) =>
    pageNumber === "..." ? (
      <span
        key={`ellipsis-${index}`}
        style={{ fontSize: "13px", color: "#444" }}
      >
        ...
      </span>
    ) : (
      <button
        key={pageNumber}
        onClick={() => setFundCurrentPage(pageNumber)}
        style={{
          border: "none",
          background: "transparent",
          padding: 0,
          color: fundCurrentPage === pageNumber ? "#2ea4e7" : "#444",
          cursor: "pointer",
          fontSize: "13px",
          fontWeight: fundCurrentPage === pageNumber ? "600" : "400",
          textDecoration:
            fundCurrentPage === pageNumber ? "underline" : "none",
        }}
      >
        {pageNumber}
      </button>
    )
)}
 
      {/* Next */}
      <button
        onClick={() =>
          setFundCurrentPage((prev) =>
            Math.min(prev + 1, fundTotalPages)
          )
        }
        disabled={
          fundCurrentPage === fundTotalPages
        }
        style={{
          border: "none",
          background: "transparent",
          color:
            fundCurrentPage === fundTotalPages
              ? "#999"
              : "#2ea4e7",
          cursor:
            fundCurrentPage === fundTotalPages
              ? "not-allowed"
              : "pointer",
          fontSize: "13px",
          padding: 0,
          display: "flex",
          alignItems: "center",
          gap: "4px",
          opacity:
            fundCurrentPage === fundTotalPages
              ? 0.5
              : 1,
        }}
      >
        Next
        <span style={{ fontSize: "20px" }}>›</span>
      </button>
    </div>
  </div>
)}
 
 
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default LimitAllocation;
